import { render } from "./FloatingWhatsAppButton.vue?vue&type=template&id=20271058&scoped=true"
import script from "./FloatingWhatsAppButton.vue?vue&type=script&lang=js"
export * from "./FloatingWhatsAppButton.vue?vue&type=script&lang=js"

import "./FloatingWhatsAppButton.vue?vue&type=style&index=0&id=20271058&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20271058"]])

export default __exports__